import { Field as FormikField, FieldProps as FormikFieldProps } from 'formik'
import React, { forwardRef, useState } from 'react'
import { KeyboardTypeOptions } from 'react-native'

import { Box } from 'widgets/Box'
import { Dropdown } from 'widgets/Dropdown'
import { Text } from 'widgets/Text'
import { TextInput } from 'widgets/TextInput'

type InputControlType = 'text' | 'password' | 'select' | 'textarea'

interface FieldProps {
  placeholder?: string
  placeholderTextColor?: string
  name?: string
  type?: InputControlType
  editable?: boolean
  label?: string
  required?: boolean
  hidden?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  disabled?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  isSearchable?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  keyboardType?: KeyboardTypeOptions
  // eslint-disable-next-line react/no-unused-prop-types
  icon?: string
  // eslint-disable-next-line react/no-unused-prop-types
  options?: any[]

  value?: any
  // eslint-disable-next-line react/no-unused-prop-types
  format?: (value: string) => string
}

export const Field = forwardRef((props: FieldProps, ref: any) => {
  const [open, setOpen] = useState(false)

  const {
    name,
    type = 'text',
    placeholder,
    placeholderTextColor,
    editable = false,
    label,
    hidden = false,
    required = false,
    value,
  } = props

  const finalProps = {
    ...props,
    ref,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
  }

  if (hidden) return null

  return (
    <Box zIndex={open ? 999 : 1} padding={{ vertical: 'sm' }}>
      {label ? (
        <Box padding={{ vertical: 'sm' }}>
          <Text bold fontSize='sm'>
            {label} {required && <Text color='error'>*</Text>}
          </Text>
        </Box>
      ) : null}
      <FormikField editable={editable} type={type} name={name} placeholder={placeholder}>
        {InputControl(finalProps)}
      </FormikField>
    </Box>
  )
})

const InputControl =
  (props: FieldProps) =>
  ({ field, meta }: FormikFieldProps) => {
    const { isSearchable = true, type = 'text', placeholderTextColor, placeholder } = props
    const isSecureTextEntry = type === 'password'
    const isMultiLine = type === 'textarea'

    switch (type) {
      case 'text':
      case 'password':
      case 'textarea':
        return (
          <TextInput
            {...props}
            {...field}
            placeholderTextColor={placeholderTextColor}
            secureTextEntry={isSecureTextEntry}
            error={meta?.error}
            touched={meta?.touched}
            numberOfLines={isMultiLine ? 4 : 1}
            multiline={isMultiLine}
          />
        )
      case 'select':
        return (
          <Dropdown
            {...props}
            {...field}
            placeholderText={placeholder}
            isSearchable={isSearchable}
            secureTextEntry={isSecureTextEntry}
            error={meta?.error}
            touched={meta?.touched}
          />
        )
      default:
        return <Box />
    }
  }
